/* Retro / Boring switch and CRT power-on for every light calculator (.lux-mini) on a product page:
   spoke (lux-spoke-mini.js), gearing and chain (lux-drive-mini.js). The choice is shared with the
   calculators page (localStorage luxCalcsStyle) and applied before paint by the inline script in
   snippets/lux-mini-modebar.liquid; this wires the buttons and the power-on, which plays when the
   accordion row opens and when the visitor switches to retro. */
(function () {
'use strict';
var FONT = 'https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap';
function init(root) {
if (!root || root.dataset.styleReady) return;
root.dataset.styleReady = '1';
var btns = root.querySelectorAll('.lux-mini__mode-btn');
function isRetro() { return root.classList.contains('lux-mini--retro'); }
function sync() {
Array.prototype.forEach.call(btns, function (b) {
var mine = b.getAttribute('data-lc-style') === 'retro';
b.setAttribute('aria-pressed', mine === isRetro() ? 'true' : 'false');
});
}
function ensureFont() {
if (document.getElementById('lux-calcs-font')) return;
var l = document.createElement('link'); l.id = 'lux-calcs-font'; l.rel = 'stylesheet'; l.href = FONT; document.head.appendChild(l);
}
function powerOn() {
if (!isRetro()) return;
root.classList.remove('lux-mini--power');
void root.offsetWidth;
root.classList.add('lux-mini--power');
}
root.addEventListener('animationend', function (e) { if (e.target === root) root.classList.remove('lux-mini--power'); });
Array.prototype.forEach.call(btns, function (b) {
b.addEventListener('click', function () {
var want = b.getAttribute('data-lc-style') === 'retro';
if (want === isRetro()) { sync(); return; }
if (want) ensureFont();
root.classList.toggle('lux-mini--retro', want);
try { localStorage.setItem('luxCalcsStyle', want ? 'retro' : 'standard'); } catch (e) {}
sync();
powerOn();
});
});
sync();
var row = root.closest ? root.closest('accordion-element') : null;
if (row && window.MutationObserver) {
new MutationObserver(function () { if (row.getAttribute('data-open') === 'true') powerOn(); }).observe(row, { attributes: true, attributeFilter: ['data-open'] });
} else {
powerOn();
}
}
function initAll(scope) {
var nodes = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('.lux-mini');
Array.prototype.forEach.call(nodes, init);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
else initAll(document);
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
window.LuxMiniStyle = { init: init, initAll: initAll };
})();
